module.exports = __webpack_public_path__ + "img/audit.bb072aea.png";